export function fullyDecodeUriComponent(value: string): string {
  let current = value

  for (let i = 0; i < 5; i += 1) {
    let next: string
    try {
      next = decodeURIComponent(current)
    } catch {
      break
    }
    if (next === current) break
    current = next
  }

  return current
}
